import { createSlice } from '@reduxjs/toolkit';

import type { TagKV } from '@/dtos/Tag';
import axiosInstance from '@/plugins/axios';
import { createAppAsyncThunk } from '@/store/thunk';

interface TagsState {
  loading: boolean;
  all: TagKV[];
}

const initialState: TagsState = {
  loading: false,
  all: []
};

export const requestAllTags = createAppAsyncThunk('tags/getAll', async () => {
  try {
    const response = await axiosInstance.get<undefined, TagKV[]>('/public/tags');
    return response;
  } catch {
    return;
  }
});

export const tagsSlice = createSlice({
  name: 'tags',
  initialState,
  reducers: {
    resetTags: (state) => {
      state.loading = false;
      state.all = [];
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(requestAllTags.pending, (state) => {
        state.loading = true;
      })
      .addCase(requestAllTags.rejected, (state) => {
        state.all = [];
        state.loading = false;
      })
      .addCase(requestAllTags.fulfilled, (state, action) => {
        if (action.payload) {
          state.all = action.payload;
        }
        state.loading = false;
      });
  }
});

export const { resetTags } = tagsSlice.actions;
